import { create } from 'sortablejs'
import { createAPI } from '../../common'

export default {
  postPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0qbqfsQfsn', 'post', config),
  getPermissionAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0qbqfsQfsn0bmm', 'get', config),
  //见报成品权限设置
  getPermissionsPaper: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfs0qfsnjttjpot', 'get', config),
  postPermissionPaper: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfs0qfsnjttjpot', 'post', config),
  // 专题权限设置
  getPermissionsSpecial: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0tqfdjbm0qfsnjttjpot', 'get', config),
  postPermissionSpecial: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0tqfdjbm0qfsnjttjpot', 'post', config),
}
